import React from 'react';
import { Link } from 'react-router-dom';

const Navbar = ({ ethAddress, openMetaMask }) => {
  return (
    <nav className="navbar navbar-expand-sm navbar-light bg-light">
      <div className="container">
        <a className="navbar-brand" href="/">
          <img src="./images/Spatial_Oracles_logo.jpeg" alt="logo" width={50} />
        </a>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo02" aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarTogglerDemo02">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <Link className="nav-link" aria-current="page" to="/">Home</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" aria-current="page" to="/map">Map</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" aria-current="page" to="/imageform">Add Image</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" aria-current="page" to="/mynft">My NFTs</Link>
            </li>
          </ul>
          <button className="btn btn-outline-success" onClick={openMetaMask}>
            {ethAddress ? ethAddress.slice(0, 7) + "..." + ethAddress.slice(39) : 'Connect to Wallet'}
          </button>
        </div>
      </div>
    </nav>
  )
}

export default Navbar;